const initCartPopupComponent = () => {
  const cartPopup = document.querySelector(".tuya-header__cart-popup");
  if (!cartPopup) return;

  const closeBtn = cartPopup.querySelector(".tuya-header__cart-popup-close");
  const itemsContainer = cartPopup.querySelector(
    ".tuya-header__cart-popup-items",
  );
  const template = document.getElementById("tuya-toast-template");
  let autoCloseTimeout;

  const popupId = cartPopup.getAttribute("id").replace("tuya-cart-popup-", "");
  const itemTemplate = document.getElementById(
    `tuya-cart-popup-item-template-${popupId}`,
  );

  const textQty = cartPopup.dataset.textQty || "";
  const moneyFormat = cartPopup.dataset.moneyFormat || "{{amount}}";
  const messages = {
    default: cartPopup.dataset.msgDefault || "",
  };

  const tuyaToast = (message, type = "error") => {
    if (!template) return;

    const existingToast = document.querySelector(".tuya-toast");
    if (existingToast) {
      existingToast.remove();
    }

    const clone = template.content.cloneNode(true);
    const toast = clone.querySelector(".tuya-toast");
    if (!toast) return;

    toast.classList.add(`tuya-toast--${type}`);
    const msgEl = toast.querySelector(".tuya-toast__message");
    if (msgEl) msgEl.textContent = message;

    document.body.appendChild(toast);
    setTimeout(() => {
      toast.classList.add("tuya-toast--out");
      setTimeout(() => toast.remove(), 320);
    }, 4000);
  };

  const formatMoney = (price) => {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(price, moneyFormat);
    }
    const parsedPrice = parseInt(price, 10);
    if (isNaN(parsedPrice)) return price;

    const formattedValue = (parsedPrice / 100).toFixed(2).replace(".", ",");
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, formattedValue);
  };

  const showPopup = async (cartData) => {
    if (autoCloseTimeout) clearTimeout(autoCloseTimeout);

    let cart = cartData;
    if (!cart || !cart.items) {
      try {
        const res = await fetch("/cart.js");
        cart = await res.json();
      } catch (e) {
        return;
      }
    }

    itemsContainer.innerHTML = "";
    if (!cart.items || cart.items.length === 0) return;

    cart.items.forEach((item) => {
      if (!itemTemplate) return;

      const clone = itemTemplate.content.cloneNode(true);
      const img = clone.querySelector(".tuya-header__cart-popup-item-image");

      if (img) {
        if (item.image) {
          img.src = item.image;
          img.alt = item.product_title || "";
        } else {
          img.closest(".tuya-header__cart-popup-item-image-wrapper")?.remove();
        }
      }

      const title = clone.querySelector(".tuya-header__cart-popup-item-title");
      if (title) title.textContent = item.product_title;

      const variant = clone.querySelector(
        ".tuya-header__cart-popup-item-variant",
      );
      if (variant) {
        const hasOnlyDefault =
          item.product_has_only_default_variant ||
          !item.variant_title ||
          item.variant_title === "Default Title";
        if (hasOnlyDefault) {
          variant.remove();
        } else {
          variant.textContent = item.variant_title;
        }
      }

      const qty = clone.querySelector(".tuya-header__cart-popup-item-qty");
      if (qty) qty.textContent = `${textQty} ${item.quantity}`;

      const price = clone.querySelector(".tuya-header__cart-popup-item-price");
      if (price) price.textContent = formatMoney(item.final_price);

      itemsContainer.appendChild(clone);
    });

    cartPopup.removeAttribute("hidden");
    startAutoClose();
  };

  const hidePopup = () => {
    cartPopup.setAttribute("hidden", "");
    if (autoCloseTimeout) clearTimeout(autoCloseTimeout);
  };

  const startAutoClose = () => {
    if (autoCloseTimeout) clearTimeout(autoCloseTimeout);
    autoCloseTimeout = setTimeout(hidePopup, 6000);
  };

  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      hidePopup();
    });
  }

  cartPopup.addEventListener("mouseenter", () => {
    if (autoCloseTimeout) clearTimeout(autoCloseTimeout);
  });

  cartPopup.addEventListener("mouseleave", startAutoClose);

  document.addEventListener("click", (e) => {
    const wrapper = document.querySelector(".tuya-header__cart-wrapper");
    if (
      wrapper &&
      !wrapper.contains(e.target) &&
      !cartPopup.hasAttribute("hidden")
    ) {
      hidePopup();
    }
  });

  document.addEventListener("cart:update", (e) => {
    const source = e.detail?.data?.source || "";
    const isAddition =
      e.detail?.action === "add" ||
      source === "product-form-component" ||
      source === "product-bundle-component" ||
      (e.constructor && e.constructor.name === "CartAddEvent") ||
      e.detail?.sourceId === "ajax-form-submit";

    if (isAddition) {
      showPopup(e.detail?.resource);
    }
  });

  document.addEventListener("submit", async (e) => {
    const form = e.target;
    const isCartAdd =
      form.action &&
      new URL(form.action, window.location.origin).pathname.endsWith(
        "/cart/add",
      );

    if (isCartAdd) {
      if (
        form.closest("product-form-component") ||
        form.closest("cart-drawer-component")
      ) {
        return;
      }

      const submitter = e.submitter;
      if (
        submitter &&
        (submitter.name === "return_to" ||
          submitter.classList.contains("tuya-product-buy-card__button--buy"))
      ) {
        return;
      }

      e.preventDefault();

      try {
        const formData = new FormData(form);
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (!response.ok) {
          let errorMessage = messages.default;
          try {
            const errorData = await response.json();
            errorMessage =
              errorData.description || errorData.message || messages.default;
          } catch (_) {}
          throw new Error(errorMessage);
        }

        const addedItem = await response.json();
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();

        document.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: form.id || "ajax-form-submit",
              action: "add",
            },
          }),
        );

        if (typeof updateCartCounts === "function") {
          updateCartCounts(cart.item_count);
        }
      } catch (err) {
        tuyaToast(err.message || messages.default);
      }
    }
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCartPopupComponent);
} else {
  initCartPopupComponent();
}
